<template>
  <div class="home caseStudiesPage">
    <template v-if="wpPageId === 1813">
      <Splash :acf="acf" :id="wpPageId" />

      <section class="caseStudies">
        <div class="container">

          <!-- Intro -->
          <div class="caseStudiesIntro">
            <div class="introLine"></div>

            <h2>
              Proven across
              <span>professional golf</span>
            </h2>

            <p>
              Discover how OCS Sport helps leading professional golf tours
              manage tournaments, scoring, websites, mobile apps and
              tournament operations.
            </p>
          </div>

          <!-- Case Studies -->
          <div class="row casesrow">

            <div
              class="col-lg-4 col-md-6 caseColumn"
              v-for="(post, index) in cases"
              :key="index"
            >

              <a
                class="caseCard"
                :href="'/#/case-studies/' + post.slug"
              >

                <!-- Image -->
                <div class="caseImageWrap">
                  <div
                    class="bkPostImage"
                    :style="{
                      'background-image': `url(${post.yoast_head_json.og_image[0].url})`
                    }"
                  ></div>

                  <div class="imageOverlay"></div>

                  <div class="readMore">
                    <span>Read case study</span>
                    <span class="arrow">→</span>
                  </div>
                </div>

                <!-- Content -->
                <div class="caseContent">

                  <div class="caseMeta">
                    OCS SPORT
                    <span></span>
                    CASE STUDY
                  </div>

                  <h3 class="postTitle">
                    {{ post.title.rendered }}
                  </h3>

                  <div class="caseLink">
                    Explore case study
                    <span>→</span>
                  </div>

                </div>

              </a>

            </div>

          </div>

        </div>
      </section>
    </template>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "@/components/footer.vue";
import Splash from "@/components/splash.vue";
export default {
  name: "Case Studies",
  components: { Footer, Splash},
  data: function() {
    return {
      acf: [],
      cases: []
    };
  },
  computed: {
    wpPageId: function(page) {
      if (this.$route.name === "case-studies") page = 1813;
      return page;
    },
  },
  methods: {
    getCases: function() {
        axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + "wp-json/wp/v2/posts/"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (this.cases = response.data)); //API data wanted pulled out        
    }
  },
  mounted() {
    this.getCases()
    axios //add API Call
      .get(
        process.env.VUE_APP_API_URL + "wp-json/wp/v2/pages/" + this.wpPageId
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => (
        this.acf = response.data
      )); //API data wanted pulled out
  },
};
</script>

<style scoped>

.caseStudiesPage {
  background: #ffffff;
}

/* =========================================
   INTRO
========================================= */

.caseStudies {
  padding: 90px 0 120px;
}

.caseStudiesIntro {
  max-width: 850px;
  margin: 0 auto 70px;
  text-align: center;
}

.introLine {
  width: 55px;
  height: 4px;
  background: #00aeef;
  margin: 0 auto 30px;
}

.caseStudiesIntro h2 {
  margin: 0 0 25px;
  font-size: 52px;
  line-height: 1.1;
  font-weight: 700;
  color: #111820;
  letter-spacing: -1px;
}

.caseStudiesIntro h2 span {
  color: #00aeef;
}

.caseStudiesIntro p {
  max-width: 720px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.7;
  color: #68717a;
}


/* =========================================
   GRID
========================================= */

.casesrow {
  margin-left: -15px;
  margin-right: -15px;
}

.caseColumn {
  padding: 15px;
  margin-bottom: 35px;
}


/* =========================================
   CARD
========================================= */

.caseCard {
  display: block;
  height: 100%;
  background: #ffffff;
  color: inherit;
  text-decoration: none !important;

  border: 1px solid #e8eaed;

  transition:
    transform 0.35s ease,
    box-shadow 0.35s ease,
    border-color 0.35s ease;

  overflow: hidden;
}

.caseCard:hover {
  transform: translateY(-8px);

  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.10);

  border-color: #d9dde1;
}


/* =========================================
   IMAGE
========================================= */

.caseImageWrap {
  position: relative;
  height: 270px;
  overflow: hidden;
}

.bkPostImage {
  position: absolute;
  inset: 0;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  transition: transform 0.6s ease;
}

.caseCard:hover .bkPostImage {
  transform: scale(1.06);
}


/* =========================================
   IMAGE OVERLAY
========================================= */

.imageOverlay {
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 35%,
      rgba(0, 0, 0, 0.65) 100%
    );

  opacity: 0.7;

  transition: opacity 0.35s ease;
}

.caseCard:hover .imageOverlay {
  opacity: 1;
}


/* =========================================
   READ MORE OVER IMAGE
========================================= */

.readMore {
  position: absolute;

  right: 25px;
  bottom: 22px;

  display: flex;
  align-items: center;

  gap: 10px;

  color: #ffffff;

  font-size: 13px;
  font-weight: 600;

  text-transform: uppercase;
  letter-spacing: 1px;

  opacity: 0;

  transform: translateY(10px);

  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.caseCard:hover .readMore {
  opacity: 1;
  transform: translateY(0);
}

.readMore .arrow {
  font-size: 20px;
  line-height: 1;
}


/* =========================================
   CONTENT
========================================= */

.caseContent {
  padding: 30px 30px 32px;
}


/* =========================================
   META
========================================= */

.caseMeta {
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 16px;

  color: #00aeef;

  font-size: 11px;
  font-weight: 700;

  letter-spacing: 1.6px;
}

.caseMeta span {
  display: block;

  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: #c8cdd2;
}


/* =========================================
   TITLE
========================================= */

.postTitle {
  margin: 0;

  color: #111820;

  font-size: 25px;
  line-height: 1.3;

  font-weight: 700;

  transition: color 0.3s ease;
}

.caseCard:hover .postTitle {
  color: #00aeef;
}


/* =========================================
   BOTTOM LINK
========================================= */

.caseLink {
  display: flex;
  align-items: center;

  gap: 8px;

  margin-top: 25px;

  color: #111820;

  font-size: 13px;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: 1px;
}

.caseLink span {
  color: #00aeef;

  font-size: 19px;

  transition: transform 0.3s ease;
}

.caseCard:hover .caseLink span {
  transform: translateX(5px);
}


/* =========================================
   SPLASH OVERRIDE
========================================= */

::v-deep .splash {
  height: auto !important;
}


/* =========================================
   RESPONSIVE
========================================= */

@media only screen and (max-width: 1200px) {

  .caseStudies {
    padding: 75px 0 90px;
  }

  .caseStudiesIntro h2 {
    font-size: 46px;
  }

  .caseImageWrap {
    height: 240px;
  }

}


@media only screen and (max-width: 992px) {

  .caseStudiesIntro {
    padding: 0 25px;
  }

  .caseStudiesIntro h2 {
    font-size: 42px;
  }

  .caseContent {
    padding: 25px;
  }

}


@media only screen and (max-width: 768px) {

  .caseStudies {
    padding: 60px 0 70px;
  }

  .caseStudiesIntro {
    margin-bottom: 45px;
  }

  .caseStudiesIntro h2 {
    font-size: 36px;
  }

  .caseStudiesIntro p {
    font-size: 16px;
  }

  .caseImageWrap {
    height: 260px;
  }

  .caseColumn {
    margin-bottom: 25px;
  }

}


@media only screen and (max-width: 480px) {

  .caseStudies {
    padding: 45px 0 55px;
  }

  .caseStudiesIntro {
    padding: 0 20px;
  }

  .caseStudiesIntro h2 {
    font-size: 31px;
  }

  .caseStudiesIntro p {
    font-size: 15px;
    line-height: 1.6;
  }

  .caseImageWrap {
    height: 220px;
  }

  .caseContent {
    padding: 22px;
  }

  .postTitle {
    font-size: 22px;
  }

  .caseLink {
    margin-top: 20px;
  }

}

</style>
